import { Routes, Route, Navigate } from "react-router-dom";
import Dashboard from "@pages/dashboard";
import Categories from "@pages/dashboard/categories";
import CreateCategory from "@pages/dashboard/categories/create";
import EditCategory from "@pages/dashboard/categories/edit";
import Brands from "@pages/dashboard/brands";
import EditBrand from "@pages/dashboard/brands/edit";
import CreateBrand from "@pages/dashboard/brands/create";
import Tags from "@pages/dashboard/tags";
import EditTag from "@pages/dashboard/tags/edit";
import CreateTag from "@pages/dashboard/tags/create";
import CreatePlatform from "@pages/dashboard/platforms/create";
import EditPlatform from "@pages/dashboard/platforms/edit";
import Platforms from "@pages/dashboard/platforms";
import CreateArticle from "@pages/dashboard/articles/create";
import EditArticle from "@pages/dashboard/articles/edit";
import Articles from "@pages/dashboard/articles";
import RoutesInstance from "./instances";
import Products from "@pages/dashboard/products";
import EditProduct from "@pages/dashboard/products/edit";
import CreateProduct from "@pages/dashboard/products/create";
import CreateGallery from "@pages/dashboard/gallery/create";
import EditGallery from "@pages/dashboard/gallery/edit";
import Gallery from "@pages/dashboard/gallery";
import ExcelPage from "@pages/dashboard/excel";

const DashboardRoutes = () => {
    return (
        <Routes>
            <Route path={RoutesInstance.dashboard}>
                <Route index element={<Dashboard />} />
            </Route>

            {/* Brands */}
            <Route path={RoutesInstance.brands}>
                <Route index element={<Brands />} />
            </Route>

            <Route path={RoutesInstance.editBrand}>
                <Route index element={<EditBrand />} />
            </Route>

            <Route path={RoutesInstance.createBrand}>
                <Route index element={<CreateBrand />} />
            </Route>

            {/* Categories */}
            <Route path={RoutesInstance.categories}>
                <Route index element={<Categories />} />
            </Route>

            <Route path={RoutesInstance.editCategory}>
                <Route index element={<EditCategory />} />
            </Route>

            <Route path={RoutesInstance.createCategory}>
                <Route index element={<CreateCategory />} />
            </Route>

            {/* Tags */}
            <Route path={RoutesInstance.tags}>
                <Route index element={<Tags />} />
            </Route>

            <Route path={RoutesInstance.editTag}>
                <Route index element={<EditTag />} />
            </Route>

            <Route path={RoutesInstance.createTag}>
                <Route index element={<CreateTag />} />
            </Route>

            {/* Platforms */}
            <Route path={RoutesInstance.platforms}>
                <Route index element={<Platforms />} />
            </Route>

            <Route path={RoutesInstance.editPlatform}>
                <Route index element={<EditPlatform />} />
            </Route>

            <Route path={RoutesInstance.createPlatform}>
                <Route index element={<CreatePlatform />} />
            </Route>

            {/* Articles */}
            <Route path={RoutesInstance.articles}>
                <Route index element={<Articles />} />
            </Route>

            <Route path={RoutesInstance.editArticle}>
                <Route index element={<EditArticle />} />
            </Route>

            <Route path={RoutesInstance.createArticle}>
                <Route index element={<CreateArticle />} />
            </Route>

            {/* Gallery */}
            <Route path={RoutesInstance.gallery}>
                <Route index element={<Gallery />} />
            </Route>

            <Route path={RoutesInstance.editGallery}>
                <Route index element={<EditGallery />} />
            </Route>

            <Route path={RoutesInstance.createGallery}>
                <Route index element={<CreateGallery />} />
            </Route>

            {/* Products */}
            <Route path={RoutesInstance.products}>
                <Route index element={<Products />} />
            </Route>

            <Route path={RoutesInstance.editProduct}>
                <Route index element={<EditProduct />} />
            </Route>

            <Route path={RoutesInstance.createProduct}>
                <Route index element={<CreateProduct />} />
            </Route>

            {/* Excel */}
            <Route path={RoutesInstance.excel}>
                <Route index element={<ExcelPage />} />
            </Route>

            <Route
                path="*"
                element={<Navigate to={RoutesInstance.dashboard} replace />}
            />
        </Routes>
    );
};

export default DashboardRoutes;
